import WeaverService from 'Services/WeaverService'
import ReactDOM from 'react-dom'
import moment from 'moment'
import projectData from 'Dummy/projectData'
import pckg from 'Root/package.json'
import { store } from '~/Store'
import semver from 'semver'
import AceEditor from 'react-ace'
import axios from 'axios'
import md5 from 'md5'
import validUrl from 'valid-url'
import { updateNodeData, updateTreeData } from 'Actions/homeTree'
import { setCurrentFiles } from 'Actions/projects'
import { DisabledRelations, DisabledTypes, GraphView, SpreadSheetView } from 'Model'
import { testNonCompliancy, nonComplianceMessage } from 'Services/SparqlComplianceService'
import { notification } from 'antd'

export isValidJSON = (val) ->
  try
    JSON.parse(val)
  catch
    false

export isBirthday = ->
  # Months are zero indexed, so 2 is March
  date = moment()
  date.date() is 5 and date.month() is 2

export castValue = (dataType, val) ->
  if Weaver.Attribute.typesBoolean.includes(dataType)
    try
      !!JSON.parse(val)
    catch
      false
  else if Weaver.Attribute.typesInteger.includes(dataType) or Weaver.Attribute.typesDouble.includes(dataType)
    +val or 0
  else if Weaver.Attribute.typesDate.includes(dataType) || Weaver.Attribute.typesTime.includes(dataType)
    date = moment(val)
    if date.isValid() then date else moment()
  else if Weaver.Attribute.typesJson.includes(dataType)
    try JSON.parse(val) catch val
  else
    '' + val

export getGravatarUrl = ({ email = '' }) ->
  "https://www.gravatar.com/avatar/#{ md5(email) }?d=identicon"

export downloadFile = (fileId, defaultName, deleteOnFinish = false) ->

  fileRef = await Weaver.File.load(fileId)

  options = {
    method: 'GET'
    headers: { 'Authorization': Weaver.getInstance().currentUser().authToken }
    url: '/api/file/download'
    responseType: 'blob'
    params: payload: {
      target: Weaver.getInstance().coreManager.currentProject.id()
      fileId
      deleteOnFinish
    }
  }

  axios(options)
    .then((response) ->
      url = window.URL.createObjectURL(new Blob([response.data]))
      link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileRef.name() or defaultName)
      document.body.appendChild(link)
      link.click()
    )

export addFileToStore = (file) ->
  { projects: { files } } = store.getState()
  store.dispatch(setCurrentFiles([files..., file]))

export getMemberKey = -> getMemberKeys()[0]

export getMemberKeys = ->
  { explore: { memberKeys } } = store.getState()
  memberKeys

export getAttributeKeys = ->
  { explore: { nameKeys } } = store.getState()
  nameKeys

export getNamespaces = ->
  { explore: { namespaces }} = store.getState()
  namespaces

export getNamespacesEnabled = ->
  { explore: { namespacesEnabled }} = store.getState()
  namespacesEnabled

export getTypeForNode = (node) ->
  if node? and type = getTypeNodeForNode(node)
    getUid(type)

export getInvertedNamespaces = ->
  { explore: { namespaces }} = store.getState()

  swap = (json) ->
    ret = {};
    for oldKey of json
      newKey = _.replace(json[oldKey], ':', '')
      ret[newKey] = oldKey;
    ret

  swap(namespaces)

export getTypeNodeForNode = (node) ->
  node? && getMemberKeys().reduce((acc, memberKey) ->
    if (types = node?.relation?(memberKey).all())?.length > 0
      [
        acc...
        _.sortBy(types, 'id').shift()
      ]
    else
      acc
  , []).shift() || undefined

export nodeHasRelevantAttributes = (node) ->
  { explore: { nameKeys } } = store.getState()
  nameKeys.find((key) -> node.attribute(key)._records.length > 0)

export getRelevantAttribute = (node) ->
  { explore: { nameKeys } } = store.getState()
  nameKeys.find((key) -> node.attribute(key)._records.length > 0)

export getNamespaceValue = (label) ->
  label = "#{label}"
  nsKey = _.values(getNamespaces()).find((nsKey) -> "#{label.split(':')[0]}:" is nsKey)
  if nsKey? and getNamespacesEnabled()
    val = _.findKey(getNamespaces(), (val) -> val is nsKey)
    label.replace(nsKey, val)
  else
    label

export getNamespaceLabel = (key) ->
  key = "#{key}"
  nsKey = _.keys(getNamespaces()).find((nsKey) -> key?.includes(nsKey))
  if (nsKey? and nsKey isnt key) and getNamespacesEnabled()
    key.replace(nsKey, getNamespaces()[nsKey])
  else
    key

testRegex = (str) ->
  defaultIdRegex = [
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/  # UUID
    /c[a-z0-9-]{24}/                                                # cuid
  ]

  idRegex = getProjectData().idRegex or defaultIdRegex
  if idRegex?
    result = false
    if _.isArray(idRegex)
      idRegex.map((regex) ->
        result = true if regex.test(str)
      )
    else
      result = idRegex.test(str)
    result
  else
    false

export getNodeLabel = (node) ->
  { explore: { typesMap } } = store.getState()
  return if not node?
  id = node.id()
  if not nodeHasRelevantAttributes(node) and testRegex(id)
    if typeNode = getTypeNodeForNode(node)
      "[ #{formatLabel(getNamespaceLabel(typesMap[getUid(typeNode)]?.label) or getNamespaceLabel(getUid(typeNode)))} ]"
    else
      "[ blank ]"
  else
    keyWithValue = getRelevantAttribute(node)
    attr = node.get?(keyWithValue)
    label = getNamespaceLabel(if attr? then attr else id)
    "#{formatLabel(label, id)}"

export formatLabel = (label, id) ->
  label

export getRelationkeyLabel = (key, id) ->
  { explore: { relationLabels } } = store.getState()
  key = relationLabels[key] or getNamespaceLabel(key)
  if getProjectData().relationKeyFn?
    getProjectData().relationKeyFn(key, id)
  else
    key

export getAttributeKeyLabel = (key) ->
  switch (key)
    when 'Thing_hasNameByLiteral_xsd' then 'Name'
    when 'Thing_hasDescriptionByLiteral_xsd' then 'Description'
    else getRelationkeyLabel(key)

export getDisabledRelations = ->
  { explore: { disabledRelations } } = store.getState()
  if getProjectData().disabledRelations?
    [getProjectData().disabledRelations..., disabledRelations...]
  else
    disabledRelations

export getDisabledTypes = ->
  { explore: { disabledTypes } } = store.getState()
  if getProjectData().disabledTypes?
    [getProjectData().disabledTypes..., disabledTypes...]
  else
    disabledTypes

export loadTreeStructureForModel = (name, version) ->
  model = await Weaver.Model.load(name, version)
  getTreeStructureForModel(model)

export getTreeStructureForModel = (model) ->
  data = {}
  { classList } = model

  for clazz, definition of classList
    data[clazz] = definition.subClasses

  data

export WeaverQuery = ->
  new Weaver.Query()

export getProjectData = ->
  { projects: { currentProject } } = store.getState()
  {
    actionsPages: []
    editPages: []
    queries: []
    groupings: []
    projectData(btoa(currentProject))...
  }

export getAttributeNode = (id) ->
  [id, graph] = splitUid(id)
  if graph?
    attNode = await new Weaver.Query().restrict(id).inGraph(graph).withAttributes().first()
  else
    attNode = await new Weaver.Query().restrict(id).withAttributes().first()
  { fromNode } = attNode
  await fromNode.load()
  attNode

export getRelationNode = (id) ->
  [id, graph] = splitUid(id)

  if graph?
    relNode = await new Weaver.Query().restrict(id).inGraph(graph).withRelations().first()
  else
    relNode = await new Weaver.Query().restrict(id).withRelations().first()
  { fromNode, toNode } = relNode
  await fromNode.load()
  await toNode.load()
  relNode

export getRelationNodeFromGraphKey = (key) ->
  [sourceId, relKey, targetId] = key.split('->')
  source = await new Weaver.Query().restrict([sourceId]).first()
  { relNode } = source.relation(relKey).allRecords().find(({ toNode }) ->
    toNode.id() is targetId
  )
  await relNode.toNode.load()
  relNode.key = relKey
  relNode

export wasNewVersionReleased = ->
  currentVersion = pckg.version
  seenVersion = localStorage.getItem('mostRecentSeenVersion') or "0.0.0"
  semver.compare(currentVersion, seenVersion) > 0


export defaultTypesTableConfig = ({ graph, id, label }) ->
  {
    title: label
    query: (sorter = { clause: '', binding: ''}, filters) ->
      { bindings, builtFilters } = buildFilters(filters)
      return nonComplianceMessage() if testNonCompliancy(typesList...)
      typesList = getMemberKeys().map((key) -> "<#{ key }>").join(' ')
      new Weaver.Sparql("""
        SELECT DISTINCT ?node WHERE {
          VALUES ?type { #{ typesList } } .
          ?node ?type <#{ id }> .
          ?node .
          #{ bindings.join('\n') }
          #{ builtFilters.join('\n') }
          #{ sorter.binding } .
        }
        #{ sorter?.clause }
      """)
    columns: undefined
    ids: await getIdsWithType(id.split('@')[0])
    subject: id
  }

export defaultNodesTableConfig = (ids) ->
  {
    title: "Table (#{ ids.length } node#{ if ids.length > 1 then 's' else '' })"
    ids: ids
    columns: undefined
  }

export sparqlFilterTypes = {
  EXACT: 'EXACT'
  CONTAINS: 'CONTAINS'
  LT: 'LT'
  GT: 'GT'
  LT_DATE: 'LT_DATE'
  GT_DATE: 'GT_DATE'
  LTE: 'LTE'
  GTE: 'GTE'
  RELATION: 'RELATION'
}

getBindings = ({ type }, key) ->
  if type is sparqlFilterTypes.RELATION
    []
  else
    ["_ ?node <#{ key }> ?#{ key.replace(/ /g, '_') } ."]

getFilterSnippet = ({ type, val }, key) ->
  safeKey = "#{ key.replace(/ /g, '_') }"
  if _.isString(val)
    val = "'#{ val }'"
  switch type
    when sparqlFilterTypes.RELATION
      """
        {
          _ ?node <#{ key }> ?#{ safeKey } .
          _ ?#{ safeKey } <name> ?#{ safeKey }Label .
          FILTER CONTAINS(?#{ safeKey }Label, #{ val }) .
        } UNION {
          ?node <#{ key }> <#{ val.slice(1, -1) }> .
          ?node <#{ key }> ?#{ safeKey } .
        }
      """
    when sparqlFilterTypes.EXACT
      "_ ?node <#{ key }> #{ val } ."
    when sparqlFilterTypes.CONTAINS
      "FILTER CONTAINS(?#{ safeKey }, #{ val }) ."
    when sparqlFilterTypes.LT
      "FILTER (?#{ safeKey } < #{ val }) ."
    when sparqlFilterTypes.GT
      "FILTER (?#{ safeKey } > #{ val }) ."
    when sparqlFilterTypes.LT_DATE
      "FILTER (str(?#{ safeKey }) < #{ val }) ."
    when sparqlFilterTypes.GT_DATE
      "FILTER (str(?#{ safeKey }) > #{ val }) ."

buildFilters = (filters = {}) ->
  _.reduce(filters, (acc, filter, key) ->
    {
      bindings: acc.bindings.concat(getBindings(filter, key))
      builtFilters: acc.builtFilters.concat(getFilterSnippet(filter, key))
    }
  , { bindings: [], builtFilters: []})

export getIdsQuery = (ids, sorter = { clause: '', binding: ''}, filters) ->
  { bindings, builtFilters } = buildFilters(filters)
  return nonComplianceMessage() if testNonCompliancy(ids...)
  sorterSelect = ''
  bind = ''
  if sorter.clause isnt '' and sorter.binding isnt ''
    sorterSelect = '?sort'
    bind = "OPTIONAL { #{ sorter.binding } }"
  new Weaver.Sparql("""
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    SELECT ?node #{sorterSelect} WHERE {
      VALUES ?node { #{ ids
        .map((id) -> id.split('@')[0])
        .map((id) -> "<#{ id }>" )
        .join(' ')
      } } .
      ?node .
      #{ bindings.join('\n') }
      #{ builtFilters.join('\n') }
      #{bind}
    }
    #{ sorter?.clause }
    """
  )

export categorizeIdsByType = (ids = []) ->
  empty = { node: [], type: [], name: [] }
  if ids.length is 0 then return empty
  if testNonCompliancy(ids..., getMemberKeys()...)
    nonComplianceMessage()
    return empty
  new Weaver.Sparql("""
    SELECT DISTINCT ?node ?type ?name WHERE {
      VALUES ?node { #{ ids
        .map((id) -> id.split('@')[0])
        .map((id) -> "<#{ id }>" )
        .join(' ')
      } } .
      ?node .
      OPTIONAL {
        VALUES ?memberKey { #{ getMemberKeys().map((key) -> "<#{ key }>").join(' ') } } .
        ?node ?memberKey ?type .
        OPTIONAL {
          ?type <name> ?name .
        }
      }
    } LIMIT 1000
    """
  ).find()

export getIdsWithType = (type) ->
  return nonComplianceMessage() if testNonCompliancy(type, getMemberKey())
  { node } = await new Weaver.Sparql("""
    SELECT DISTINCT ?node WHERE {
      _ ?node <#{ getMemberKey() }> <#{ type }> .
    }
    """
  ).find()
  node.map((n) -> n.id())

export getRelKeyBindings = ->
  await new Weaver.Sparql("""
    SELECT DISTINCT ?key WHERE {
      ?s ?key ?o .
      FILTER(isIRI(?o))
    }
  """).find()

export getBooleanLabel = (key, val) ->
  labels = getProjectData().booleanLabels or {}
  if labels[key]?[val.toString()]?
    labels[key]?[val.toString()]
  else
    val

export getQueryResults = (q) ->
  if q instanceof Weaver.Sparql
    q.findNodes()
  else
    q.find()

export getRenderedJson = (data) ->
  if _.isObject(data)
    data = JSON.stringify(data, null, 2)

  <AceEditor
    style={{
      margin: '15px'
      borderRadius: '10px'
      width: '400px'
    }}
    fontSize={14}
    mode="json"
    theme="solarized_light"
    autoScrollEditorIntoView={true}
    showGutter={true}
    highlightActiveLine={true}
    defaultValue={data}
    setOptions={{
      useWorker: false,
      readOnly: true,
      highlightActiveLine: false,
      highlightGutterLine: false,
      maxLines: 1000,
      autoScrollEditorIntoView: false,
      showLineNumbers: true
    }}
  />

resetConfigDisabledItems = (space) ->
  disabledTypes = await DisabledTypes.load()
  disabledRelations = await DisabledRelations.load()
  node.unset('value') for node in [disabledTypes, disabledRelations]

export clearSpace = (space) ->
  return unless space
  #await resetConfigDisabledItems(space)
  branches = await Weaver.Branch.list(space.id())
  branchesToDelete = branches.filter((branch) -> branch.id() isnt '$config')
  await Promise.all(branchesToDelete.map((branch) ->
    await branch.unprotect() if branch.isProtected()
    Weaver.Branch.deleteBranch(branch.id(), { target: space.id() }))
  )
  Weaver.Branch.createBranch('main', 'Main', { target: space.id() })

export getUid = (node, graph) ->
  if node.id?
    if typeof node.id is 'function'
      id = node.id()
    else
      id = node.id
    graph = node.graph
  else if node.uid
    id = node.uid
    graph = undefined if graph is 'undefined' or graph is 'null'
  else
    id = node
    graph = undefined if graph is 'undefined' or graph is 'null'

  "#{ id }#{ if graph then ('@' + graph) else ''}"

export splitUid = (id) ->
  [id, graph] = id.split('@')
  graph = undefined if graph is 'undefined'
  [id, graph]

export mapListener = (object, fn) ->
  handler = {
    get: (target, property, receiver) ->
      try
        new Proxy(target[property], handler)
      catch err
        Reflect.get(target, property, receiver)
    defineProperty: (target, property, descriptor) ->
      fn()
      Reflect.defineProperty(target, property, descriptor)
    deleteProperty: (target, property) ->
      fn()
      Reflect.deleteProperty(target, property)
  }

  new Proxy(object, handler)

export checkPluginAvailibility = (pluginName) ->
  available = true
  try
    plugins = store.getState().explore.plugins
    plugins[pluginName]
  catch
    available = false
  available

export removeElem = (container) ->
  unmountResult = ReactDOM.unmountComponentAtNode(container)
  if unmountResult and container.parentNode
    container.parentNode.removeChild(container)

export getAppViews = ->
  graphViews = await GraphView.list(
    { authenticated: WeaverService.isAuthenticated() }
  )
  graphViews

export getAppViewFromId = (id) ->
  views = await getAppViews()
  views.find((view) -> view.id() is id)

oldLoadRef = Weaver.Node.load
Weaver.Node.load = (nodeId, params = {}) ->
  [id, graph] = splitUid(nodeId)
  params.graph ?= graph
  oldLoadRef.call(@, id, params)

uidObj = (node) ->
  {
    id: node.id()
    graph: node.getGraph()
  }

export showBootstrapFeedback = (msg) ->
  [message, description] = msg.split('%')
  notificationInfo = {
    message
    duration: 5
    description
  }
  if description.trim() is "Write access is required to update the project. Some functionality might not work as expected."
    notification.warn(notificationInfo)
  else
    notification.error(notificationInfo)

export isUrl = (string) ->
  validUrl.isUri("#{ string }")

export isValidNamespaceUrl = (string) ->
  urlPattern = new RegExp('^(https?:\\/\\/)?'+ # validate protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ # validate domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ # validate OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ # validate port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ # validate query string
    '(\\#[-a-z\\d_]*)?$','i'); # validate fragment locator
  !!urlPattern.test(string);

export decode = (string) ->
  decodeURIComponent(string);

export enc = (string) ->
  encodeURIComponent(string);

Weaver.Query.prototype.getNodeIdFromStringOrNode = (node) ->
  if _.isString(node)
    [id, graph] = splitUid(node)
    if graph
      { id, graph }
    else
      id
  else if node instanceof Weaver.Node
    uidObj(node)
  else if _.isObject(node) and node.id?
    node
  else
    throw new Error("Unsupported type: #{node}")
